<template>
    <div>
        <h1 style="font-size: 24px; color: black;">活动配置 </h1>
        <div style="margin-bottom: 10px;">
            <el-tabs type="border-card" v-model="activeName"  @tab-click="handleClick">
                <el-tab-pane label="周抽活动" name="first" >
                    <el-col >
                        <el-card shadow="hover">
                            <span>渠道名称：</span>
                            <el-cascader v-model="queryData.subChannels" :options="channelList" :props="optionProps" clearable
                                         collapse-tags>
                            </el-cascader>
                            <el-button class="sub-sub" type="primary" @click="searchActivitiesByChannel">查询</el-button>
                            <el-button class="sub-sub1" type="primary" @click="showAddActivityFormDialog(0,'创建活动')">添加活动</el-button>
                        </el-card>
                    </el-col>
                    <el-col>
                        <el-table
                                :data="activityList"
                                border
                                :fit="true">
                            <el-table-column label="活动名称" prop="name"></el-table-column>
                            <el-table-column label="渠道关联" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.subChannels.length===subChannels.length?'全部':scope.row.subChannelNames.join(" , ")}}
                                </template>
                            </el-table-column>
                            <el-table-column label="活动类型">
                                <template slot-scope="scope">
                                    {{ scope.row.activityCircleTypeEnum.name}}
                                </template>
                            </el-table-column>
                            <el-table-column label="活动开放时间" align="center">
                                <template slot-scope="scope">
                                    {{ formatDate(scope.row.startDt,"YYYY-MM-DD") +' 至 '+ formatDate(scope.row.endDt,"YYYY-MM-DD")}}
                                </template>
                            </el-table-column>
                            <el-table-column label="开奖时间"  align="center">
                                <template slot-scope="scope">
                                    {{scope.row.weekEnum.name+' '+formatDate(scope.row.prizeDt,"HH:mm:ss")}}
                                </template>
                            </el-table-column>
                            <el-table-column label="发券时间" align="center">
                                <template slot-scope="scope">
                                    <div>
                                        {{scope.row.ticketStartWeekEnum.name+' '+formatDate(scope.row.ticketStartDt,"HH:mm:ss")}}
                                    </div>
                                    <div>
                                        {{scope.row.ticketEndWeekEnum.name+' '+formatDate(scope.row.ticketEndDt,"HH:mm:ss")}}
                                    </div>

                                </template>
                            </el-table-column>
                            <el-table-column label="分享奖励上限" prop="shareLimitDaily" align="center"></el-table-column>
                            <el-table-column label="活动状态"  align="center">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.startDt > now ">待开始</div>
                                    <div v-if="scope.row.startDt < now && now<scope.row.endDt">进行中</div>
                                    <div v-if="scope.row.endDt < now">已结束</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作"  align="center">
                                <template slot-scope="scope">
                                    <el-button plain size="mini" type="info" @click="showAddActivityFormDialog(2,'活动详情',scope.row)">详情</el-button>
                                    <el-button plain size="mini" type="primary" @click="showAddActivityFormDialog(1,'编辑活动',scope.row)">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-tab-pane>
                <el-tab-pane label="日常活动" name="second">
                    <el-col >
                        <el-card shadow="hover">
                            <el-button  type="primary" @click="addDailyActivity">添加活动</el-button>
                        </el-card>
                    </el-col>
                    <el-col >
                        <el-table
                                :data="pieceList"
                                border
                                :fit="true">
                            <el-table-column label="活动名称" prop="name"></el-table-column>
                            <el-table-column label="创建时间"  >
                                <template slot-scope="scope">
                                    {{ formatDate(scope.row.createDt,"YYYY-MM-DD HH:mm:ss")}}
                                </template>
                            </el-table-column>
                            <el-table-column label="活动周期">
                                <template slot-scope="scope">
                                    {{ scope.row.circleType.name}}
                                </template>
                            </el-table-column>
                            <el-table-column label="活动类型">
                                <template slot-scope="scope">
                                    {{ scope.row.activityType.name}}
                                </template>
                            </el-table-column>
                            <el-table-column label="活动备注" prop="detail"></el-table-column>
                            <el-table-column label="是否显示" align="center" width="150px">
                                <template slot-scope="scope">
                                    <el-switch v-model="scope.row.isUse"
                                               :active-value="true"
                                               :inactive-value="false"
                                               active-text="显示"
                                               inactive-text="隐藏"
                                               @change="update(scope.row)">
                                    </el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center">
                                <template slot-scope="scope">
                                <el-button plain size="small" type="primary" @click="configPrize(scope.row)">物品配置</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="page.page"
                                    :page-sizes="[20,50,100]"
                                    :page-size="page.size"
                                    layout="total, sizes, prev, pager, next"
                                    :total="page.totalElements">
                            </el-pagination>
                    </el-col>
                </el-tab-pane>
            </el-tabs>
        </div>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogActivityVisible" width="1200px">
            <el-form :model="addActivityForm">
                <el-form-item label="活动名称 :" :label-width="labelWidth">
                    <el-input :disabled="dialogType===2 || showStartDt===true" type="text" v-model="addActivityForm.name" maxlength="50"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="活动类型 :" :label-width="labelWidth">
                    <el-select :disabled="dialogType===2 || showStartDt===true" v-model="addActivityForm.circleType" placeholder="请选择">
                        <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                :disabled="item.id!==2">
                        </el-option>
                    </el-select>
                    <el-tag type="warning" effect="plain">目前固定按周循环</el-tag>
                </el-form-item>
                <el-form-item label="开奖时间 :" :label-width="labelWidth">
                    <el-select :disabled="dialogType===2 || showStartDt===true" v-model="addActivityForm.prizeNumber" placeholder="请选择">
                        <el-option
                                v-for="item in weeks"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <el-time-picker :disabled="dialogType===2 || showStartDt===true" v-model="addActivityForm.prizeDt"  placeholder="任意时间点"></el-time-picker>
                </el-form-item>
                <el-form-item label="发券时间 :" :label-width="labelWidth">
                    <h4>
                        开始:
                        <el-select :disabled="dialogType===2 || showStartDt===true" v-model="addActivityForm.ticketStartNumber" placeholder="请选择">
                            <el-option
                                    v-for="item in weeks"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <el-time-picker :disabled="dialogType===2 || showStartDt===true"  v-model="addActivityForm.ticketStartDt"   placeholder="任意时间点"></el-time-picker>
                    </h4>
                    <h4>
                        结束:
                        <el-select :disabled="dialogType===2 || showStartDt===true" v-model="addActivityForm.ticketEndNumber" placeholder="请选择">
                            <el-option
                                    v-for="item in weeks"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <el-time-picker :disabled="dialogType===2 || showStartDt===true" v-model="addActivityForm.ticketEndDt"  placeholder="任意时间点"></el-time-picker>
                    </h4>
                </el-form-item>
                <el-form-item label="奖品配置 :" :label-width="labelWidth">
                    <el-button :disabled="dialogType===2" circle icon="el-icon-plus" size="mini" type="primary" @click="addPrize"></el-button>
                    <el-table
                            :data="addActivityForm.prizeList"
                            border
                            :fit="true">
                        <el-table-column label="编号" type="index" width="50px" align="center"></el-table-column>
                        <el-table-column label="奖品类型" width="113px" align="center">
                            <template slot-scope="scope">
                                <el-select :disabled="dialogType===2" v-model="scope.row.level" placeholder="请选择" size="mini">
                                    <el-option
                                            v-for="level in levels"
                                            :key="level.id"
                                            :label="level.name"
                                            :value="level.id">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="奖品名称" width="121px" align="center">
                            <template slot-scope="scope">
                                <el-select :disabled="dialogType===2" v-model="scope.row.prize.id" placeholder="请选择" size="mini"  >
                                    <el-option
                                            v-for="prize in prizes"
                                            :key="prize.id"
                                            :label="prize.name"
                                            :value="prize.id">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="单用户（号码）奖品发放数量" width="151px" align="center">
                            <template slot-scope="scope">
                                <el-input-number :disabled="dialogType===2" size="mini" :min="1" v-model="scope.row.winNumber"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="真实中奖号码数" width="151px" align="center">
                            <template slot-scope="scope">
                                <el-input-number :disabled="dialogType===2" size="mini" :min="0" v-model="scope.row.trueNumber"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="虚拟中奖号码数"  width="151px" align="center">
                            <template slot-scope="scope">
                                <el-input-number :disabled="dialogType===2" size="mini" :min="100" v-model="scope.row.vmNumber"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="虚拟中奖人数"  width="151px" align="center">
                            <template slot-scope="scope">
                                <el-input-number :disabled="dialogType===2" size="mini" :min="100" v-model="scope.row.vmUserNumber"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="汇总" align="center" width="70px">
                            <template slot-scope="scope">
                                {{scope.row.trueNumber*scope.row.winNumber}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="80px">
                            <template slot-scope="scope">
                                <el-button :disabled="dialogType===2" circle icon="el-icon-minus" size="mini" type="danger"
                                           @click.native.prevent="reducePrize(scope.$index,addActivityForm.prizeList)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                </el-form-item>
                <el-form-item label="分享奖励上限 :" :label-width="labelWidth">
                    单用户一天分享奖励上限
                    <el-input-number :disabled="dialogType===2" :min="1" size="small" v-model="addActivityForm.shareLimitDaily"></el-input-number>
                    次
                </el-form-item>
                <el-form-item label="活动开放时间 :" :label-width="labelWidth">
                    <el-date-picker
                            :disabled="dialogType===2 || showStartDt===true"
                            v-model="addActivityForm.startDt"
                            type="datetime"
                            placeholder="开始时间">
                    </el-date-picker>
                    <span>至</span>
                    <el-date-picker
                            :disabled="dialogType===2"
                            v-model="addActivityForm.endDt"
                            type="datetime"
                            placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="活动规则 :" :label-width="labelWidth">
                    <el-input
                            :disabled="dialogType===2"
                            type="textarea"
                            autosize
                            placeholder="请输入内容"
                            v-model="addActivityForm.detail">
                    </el-input>
                </el-form-item>
                <el-form-item label="渠道筛选 :" :label-width="labelWidth">
                    <el-cascader :disabled="dialogType===2" v-model="addActivityForm.subChannels" :options="channelList" :props="optionProps"
                                 clearable collapse-tags>
                    </el-cascader>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmActivityForm" :disabled="dialogType===2" >提 交</el-button>
                    <el-button type="info" @click="dialogActivityVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        channelList,
        activityList,
        saveActivity,
        updateActivity,
        allSelectData,
        searchActivitiesByChannel,
        pieceActivityList,
        savePieceActivity,
    } from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "ActivityConfig",
        data() {
            return {
                activeName:'first',
                today:'',
                now:'',
                dialogActivityVisible: false,
                showStartDt:false,
                activityList:[],
                channelList: [],
                subChannelList: [],
                subChannels: [],
                subChannelNames:[],
                queryData: {
                    subChannels: [],
                },
                queryPiece:{
                    name: null,
                    size: null,
                    page: null
                },
                optionProps: {
                    emitPath: false,
                    multiple: true,
                    value: 'subChannel',
                    label: 'name',
                    children: 'children',
                },
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                prizeList: [],
                addActivityForm: {
                    id: 0,
                    name: '',
                    circleType: 2,
                    prizeNumber: 1,
                    prizeDt: '',
                    ticketStartNumber: 1,
                    ticketStartDt: '',
                    ticketEndNumber: 1,
                    ticketEndDt: '',
                    shareLimitDaily: '',
                    detail: '',
                    startDt: '',
                    endDt:'',
                    createDt: '',
                    updateDt: '',
                    prizeList: [],
                    subChannels: [],
                },
                addPrizeForm: {
                    id: 0,
                    activityConfigId: 0,
                    prize:{id:1},
                    level: 1,
                    winNumber: 1,
                    trueNumber: 1,
                    vmNumber: 1,
                    vmUserNumber:1,
                },
                dialogTitle: '',
                dialogType: 0,
                labelWidth: '110px',
                options: [],
                weeks: [],
                levels: [],
                prizes: [],
                pieceList:[],
                piece:{},
            }
        },
        methods: {
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            handleClick(tab) {
                this.activeName = tab.name;
                if (tab.name === 'second'){
                    this.queryPieces();
                }
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.queryPieces();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryPieces();
            },
            queryPieces(){
                this.queryPiece.page = this.page.page;
                this.queryPiece.size = this.page.size;
                pieceActivityList(this.queryPiece).then(resp =>{
                    this.pieceList = resp.data.info.list;
                    this.page.totalElements = resp.data.info.totalElements;
                })
            },
            addDailyActivity() {
               this.$router.push({ path: '/dailyActivity'});
            },
            configPrize(dailyActivity){
                this.$store.commit('jump', dailyActivity);
                this.$router.push({ path: '/addPrize'});
            },
            update(_data){
                this.piece.id = _data.id;
                this.piece.isUse = _data.isUse;
                this.piece.name = _data.name;
                this.piece.circleType = _data.circleType.id;
                this.piece.detail = _data.detail;
                this.piece.activityType = _data.activityType.id;
                savePieceActivity(this.piece).then(resp => {
                    if (resp.data.status === 0 ){
                        this.queryPieces();
                    }
                });
            },
            showAddActivityFormDialog(_type, _title, _data) {
                this.dialogType = _type;
                this.dialogTitle = _title;
                this.showStartDt = false;
                this.addActivityForm={
                        id: 0,
                        name: '',
                        circleType: 2,
                        prizeNumber: 1,
                        prizeDt: '',
                        ticketStartNumber: 1,
                        ticketStartDt: '',
                        ticketEndNumber: 1,
                        ticketEndDt: '',
                        shareLimitDaily: '',
                        detail: '',
                        startDt:'',
                        endDt:'',
                        createDt: '',
                        updateDt: '',
                        prizeList: [],
                        subChannels: [],
                };
                if (_data) {
                    if (new Date(_data.startDt) < new Date() && new Date() <new Date(_data.endDt)){
                        this.showStartDt = true;
                    }
                    if (new Date() >new Date(_data.endDt)){
                        this.dialogType = 2;
                    }
                    let tempSubChannel=[];
                    _data.subChannels.forEach(function (subChannel) {
                       tempSubChannel.push(subChannel.subChannel.subChannel);
                    });
                    this.addActivityForm = {
                        id: _data.id,
                        name: _data.name,
                        circleType: _data.circleType,
                        prizeNumber: _data.prizeNumber,
                        prizeDt: _data.prizeDt,
                        ticketStartNumber: _data.ticketStartNumber,
                        ticketStartDt: _data.ticketStartDt,
                        ticketEndNumber: _data.ticketEndNumber,
                        ticketEndDt: _data.ticketEndDt,
                        shareLimitDaily: _data.shareLimitDaily,
                        detail: _data.detail,
                        startDt:_data.startDt,
                        endDt: _data.endDt,
                        createDt: _data.createDt,
                        updateDt: _data.updateDt,
                        prizeList:JSON.parse(JSON.stringify(_data.prizeList)) ,
                        subChannels: tempSubChannel,
                    }
                }
                this.dialogActivityVisible = true;
            },

            searchActivitiesByChannel(){
                let _this= this;
                searchActivitiesByChannel(this.queryData.subChannels).then(resp=>{
                    this.activityList = resp.data.info;
                    this.activityList.forEach(function (activity){
                        activity.subChannels.forEach(function (sub) {
                            _this.subChannelNames.push(sub.subChannel.name);
                        });
                        _this.$set(activity,'subChannelNames',_this.subChannelNames);
                        _this.subChannelNames=[];
                    })
                })
            },

            confirmActivityForm(){
                let _message = '';
                if(this.addActivityForm.name===''){
                    _message = '请输入活动名称'
                }else if (this.addActivityForm.prizeDt===''){
                    _message = '请选择开奖时间'
                }else if (this.addActivityForm.ticketStartDt===''){
                    _message = '请选择发券开始时间'
                }else if (this.addActivityForm.ticketEndDt===''){
                    _message = '请选择发券结束时间'
                } else if (this.addActivityForm.prizeList.length<1){
                    _message = '请添加活动奖品'
                }else if (this.addActivityForm.startDt==='' || this.addActivityForm.startDt<=new Date()){
                    _message = '请重新选择开始时间'
                }else if (this.addActivityForm.endDt==='' || this.addActivityForm.endDt<this.addActivityForm.startDt){
                    _message = '请重新选择结束时间'
                } else if (this.addActivityForm.subChannels.length<1){
                    _message = '请选择相关渠道'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
               if(this.dialogType ===1){
                   updateActivity(this.addActivityForm.id,this.addActivityForm).then(resp=>{
                       console.log(resp.data.status);
                       if(resp.data.status===1){
                           this.searchActivitiesByChannel();
                           this.dialogActivityVisible=false;
                       }
                   });
               }else {
                   saveActivity(this.addActivityForm).then(resp=>{
                       if(resp.data.status===0){
                           this.searchActivitiesByChannel();
                           this.dialogActivityVisible=false;
                       }
                   });
               }
            },
            addPrize() {
                this.addActivityForm.prizeList.push({
                    id: 0,
                    activityConfigId: 0,
                    prize: {id:1},
                    level: 1,
                    winNumber: 1,
                    trueNumber: 1,
                    vmNumber: 1,
                    vmUserNumber:1,
                })
            },
            reducePrize(index, rows) {
                rows.splice(index, 1);
            }

        },
        created() {
            this.today = utils.TodayUtil.getToday();
            this.now = utils.DateUtil.formatDate(new Date(),"yyyy-MM-DDTHH:mm:ss.SSSZ");
            channelList().then(resp => {
                let _this = this;
                this.channelList = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                    if (channel.children) {
                        channel.children = channel.children.filter(sub => sub.state === 1)
                    }
                    return channel;
                }).filter(channel => channel.children && channel.children.length);
                this.channelList.forEach(function (channel) {
                    _this.$set(channel, 'subChannel', channel.id);
                    channel.children.forEach(function (sub) {
                        _this.subChannelList.push(sub);
                        _this.subChannels.push(sub.subChannel);
                    })
                });
            });
            activityList().then(resp =>{
                let _this= this;
                this.activityList = resp.data.info;
                this.activityList.forEach(function (activity){
                    activity.subChannels.forEach(function (sub) {
                        _this.subChannelNames.push(sub.subChannel.name);
                    });
                    _this.$set(activity,'subChannelNames',_this.subChannelNames);
                    _this.subChannelNames=[];
                })
            });
            allSelectData().then(resp =>{
                this.options = resp.data.info.activityCircleTypes;
                this.weeks = resp.data.info.weeks;
                this.levels = resp.data.info.prizeLevels;
                this.prizes = resp.data.info.prizes;
            });

            if(this.$route.params.activeName){
                this.activeName = this.$route.params.activeName;
                this.queryPieces();
            }
        }
    }
</script>

<style scoped>

</style>